module.exports = __webpack_public_path__ + "assets/img/6june_light.f60a6885.jpeg";